import { Component, computed, ElementRef, input, viewChild } from '@angular/core';
import { apiUrl } from '@app/app.constants';
import { PortalMedia } from '@app/core/interfaces/portal-media';
import { watch } from '@app/utils/signals/watch';
import { isBlank } from '@app/utils/string';

@Component({
  selector: 'portal-rich-text',
  standalone: true,
  imports: [],
  templateUrl: './rich-text.component.html',
  host: {
    class: 'rich-text',
  },
})
export class RichTextComponent {
  content = input.required<string>();
  media = input.required<PortalMedia | undefined>();
  contentEl = viewChild<ElementRef<HTMLElement>>('contentEl');
  imageUrl = computed(() =>
    this.media() != null ? apiUrl(`/reseller/media/${this.media().id}/download`) : null
  );

  constructor() {
    watch([this.contentEl, this.content], ([contentEl]) => {
      if (contentEl != null) {
        this.updateLinks(contentEl.nativeElement);
      }
    });
  }

  private updateLinks(element: HTMLElement): void {
    element.querySelectorAll('a').forEach((element) => {
      if (isBlank(element.target)) {
        element.target = '_blank';
      }
    });
  }
}
